"use client";

import { Stethoscope, BriefcaseMedical, Syringe, HeartPulse } from "lucide-react";
import Link from "next/link";
import { serviceCategories } from "@/data/mockData";
import { useI18n } from "@/i18n/I18nProvider";

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string; strokeWidth?: number }>> = {
  stethoscope: Stethoscope, hospital: BriefcaseMedical, scalpel: Syringe, "heart-pulse": HeartPulse,
};

export default function ServiceCategories() {
  const { t } = useI18n();
  return (
    <section className="px-5 mt-4">
      <div className="grid grid-cols-4 gap-2.5">
        {serviceCategories.map((cat) => {
          const Icon = iconMap[cat.icon] ?? Stethoscope;
          return (
            <Link
              key={cat.id}
              href={`/services?category=${cat.id}`}
              className="flex flex-col items-center justify-center gap-2 h-[88px] rounded-2xl px-1 transition-transform active:scale-95"
              style={{ backgroundColor: cat.bgColor }}
            >
              <span style={{ color: cat.color }}>
                <Icon size={28} strokeWidth={2} />
              </span>
              <span className="text-[12px] font-bold text-text-dark text-center leading-[1.25]">
                {t(cat.title)}
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
